import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import { cloneDeep, isEmpty, sortBy } from "lodash";

import type { IEquipmentFunctionalityType, IResponseWithLoading } from "App/Modules/Models";
import { DirectConnectionTypeFunctions } from "App/Modules/Models/Models/DirectConnectionTypeFunctions";
import type { IAvailableChannel } from "App/Modules/Models/Models/IAvailableChannel";
import type { IEquipmentFunctionalityTypesRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class EditVideoPropertiesComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "irEquipmentFunctionalityTypesRepository", "$translate"];

    public resolve: IFormContainerResolve<IEquipmentFunctionalityType, void>;

    public editResponse: IResponseWithLoading<IEquipmentFunctionalityType>;

    public equipmentFunctionalityType: IEquipmentFunctionalityType;

    public originalEquipmentFunctionalityType: IEquipmentFunctionalityType;

    public supportedDirectConnectionsOptions: any;

    constructor(
        private readonly $scope: IScope,
        private readonly equipmentFunctionalityTypesRepository: IEquipmentFunctionalityTypesRepository,
        private readonly $translate: angular.translate.ITranslateService,
    ) {}

    public $onInit() {
        this.resolve.formData.availableChannels = sortBy(this.resolve.formData.availableChannels, (c) =>
            c.name.toLowerCase(),
        );

        this.originalEquipmentFunctionalityType = this.resolve.formData;
        this.equipmentFunctionalityType = cloneDeep(this.originalEquipmentFunctionalityType);

        this.supportedDirectConnectionsOptions = DirectConnectionTypeFunctions.GetDirectConnectionTypeDictionary(
            this.$translate,
        );
    }

    public addAvailableChannel() {
        this.equipmentFunctionalityType.availableChannels.push({
            name: "",
            supportedDirectConnections: [],
        } as IAvailableChannel);
    }

    public deleteAvailableChannel(index: number) {
        this.equipmentFunctionalityType.availableChannels.splice(index, 1);
    }

    public editIOProperties() {
        const patchObject = {} as IEquipmentFunctionalityType;

        patchObject.availableChannels = this.equipmentFunctionalityType.availableChannels;

        if (!isEmpty(patchObject)) {
            extendWithLoadingAndFail(
                this.equipmentFunctionalityTypesRepository.patchEquipmentFunctionalityType(
                    this.equipmentFunctionalityType.id,
                    patchObject,
                ),
            )
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (editResponse: IResponseWithLoading<IEquipmentFunctionalityType>) => {
                        this.editResponse = editResponse;
                        if (!editResponse.isLoading && editResponse.data) {
                            this.resolve.options.onOk(editResponse.data);
                        }
                    },
                    (errorResponse) => {
                        this.editResponse = errorResponse;
                    },
                );
        } else {
            this.cancel();
        }
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }
}
